import React from 'react'
import { PeopleOverview } from '../components/PeopleOverview'
import { useFetchPeople } from '../hooks/useFetchPeople'

export const AllPeopleOverview = () => {
  const {
    people,
    totalCount,
    loading,
    pageIndex,
    setPageIndex,
    pageSize,
    setPageSize,
    dateRange,
    sortBy,
    onSearchChange,
    onDateRangeChange,
    onSortChange,
    refetch,
  } = useFetchPeople()

  return (
    <PeopleOverview
      title="All People"
      serverSide
      loading={loading}
      people={people}
      totalCount={totalCount}
      pageIndex={pageIndex}
      onPageChange={setPageIndex}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      dateRange={dateRange}
      onDateRangeChange={onDateRangeChange}
      sortBy={sortBy}
      onSortChange={onSortChange}
      onSearchChange={onSearchChange}
      refresh={refetch}
    />
  )
}
